import { render } from "./ButtonIcon.vue?vue&type=template&id=14f07d6a"
import script from "./ButtonIcon.vue?vue&type=script&lang=js"
export * from "./ButtonIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__